import { render, staticRenderFns } from "./AttachResource.vue?vue&type=template&id=ca46e540"
import script from "./AttachResource.vue?vue&type=script&lang=js"
export * from "./AttachResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports